import React, { FunctionComponent } from 'react';

import { BusinessContactStep as CommonBusinessContact } from 'scenes/common/components/Steps';
import { getBusinessContactName } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';

const BusinessContactStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const { firstName, lastName } = getBusinessContactName(funnelState);

  return (
    <CommonBusinessContact
      onNext={onNext}
      defaultFirstName={firstName}
      defaultLastName={lastName}
    />
  );
};

export default BusinessContactStep;
